import * as yup from 'yup';

export const validationSchemaResearchMunicipalNumber = yup.object().shape({
  dateFrom: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
  dateTo: yup
    .date()
    .nullable()
    .required('Campo obbligatorio')
    .typeError('Data non valida')
    .when('dateFrom', (dateFrom, formvalidationSchema) =>
      dateFrom && dateFrom?.toString() !== 'Invalid Date'
        ? formvalidationSchema.min(dateFrom, 'La data deve essere maggiore o uguale della Data da')
        : formvalidationSchema.nullable()
    ),
});
